module.exports = __webpack_public_path__ + "media/images/scorecards_empty-1cefd8939616c19ac6ddb11bee015291.svg";